import { Routes } from '@angular/router';

import { OauthCallbackComponent } from '@mark/common-lib/components';

import { RouteString } from './core/enums/route-string';

export const routes: Routes = [
  {
    path: 'login/oauth/callback',
    component: OauthCallbackComponent,
  },
  {
    path: ``,
    loadComponent: () => import('./pages/main/main.component').then((m) => m.MainPageComponent),
    pathMatch: 'full',
  },
  // {
  //   path: `${RouteString.MAIN}`,
  //   loadComponent: () => import('./pages/main/main.component').then((m) => m.MainPageComponent),
  // },
  // {
  //   path: `${RouteString.NOT_FOUND}`,
  //   loadComponent: () => import('./pages/not-found/not-found.component').then((m) => m.NotFoundComponent),
  // },
  // {
  //   path: `${RouteString.ERROR}`,
  //   loadComponent: () => import('./pages/error/error.component').then((m) => m.ErrorComponent),
  // },
  { path: '**', redirectTo: `` },
];
